import { useRef, useEffect } from 'react';
import type { UsePrevious } from './types';

const usePrevious: UsePrevious = value => {
  const ref = useRef<typeof value>();

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
};

export default usePrevious;
